<template>
  <div class="flex flex-col justify-center items-center text-center max-w-2xl mx-auto mt-10">
    <div class="relative flex items-center justify-center p-8">
      <BaseIcon size="50" :filled="true" class="text-on-primary-container z-20">{{
        icon
      }}</BaseIcon>
      <BaseShape
        shape="12-sided-cookie"
        class="w-full h-full absolute text-primary-container z-10"
      />
    </div>
    <h3 class="text-headline-small mt-4 mb-1">{{ title }}</h3>
    <p class="text-body-large mb-8 text-on-surface-variant">
      {{ description }}
    </p>
    <slot />
  </div>
</template>
<script setup lang="ts">
import BaseIcon from '../base/icon/BaseIcon.vue'
import BaseShape from '../base/shapes/BaseShape.vue'

interface Props {
  title: string
  description: string
  icon: string
}

const { title, description, icon } = defineProps<Props>()
</script>
